import { createFileRoute } from '@tanstack/react-router'
import { WorkbookEditorPage, validateEditorSearch } from '@bloo-team/product-vantage'

/**
 * Composer shim (S5.0, docs/modularization.md §Route mounting): route
 * infrastructure stays in the app's tree; the surface lives in
 * @bloo-team/product-vantage. `?wb=` targets the workbook — the legacy
 * `?wbId=` deep links land here through LEGACY_REDIRECTS. `?tab=` picks
 * Settings / History (absent = Blocks); `?relative=` is time travel;
 * `?version=` shows an old version read-only.
 */
function WorkbookRoute() {
  const { clusterId, scopeId } = Route.useParams()
  const { wb, tab, relative, version } = Route.useSearch()
  return (
    <WorkbookEditorPage clusterId={clusterId} scopeId={scopeId} wb={wb} tab={tab} relative={relative} version={version} />
  )
}

export const Route = createFileRoute('/$clusterId/$scopeId/vantage/detections_/workbook')({
  validateSearch: validateEditorSearch,
  component: WorkbookRoute,
})
